<template>
  <div class="container">
    <!-- 新增移动端图片容器，便于单独控制 -->
    <div class="mobile-image-container">
      <img class="ipad-image" src="../static/home/s_01.png" alt="产品展示图">
    </div>
    <p class="container-p">{{ $t('home.s_arrived') }}</p>
    <p class="container-p2">{{ $t('home.power') }}</p>
    <div class="button-group">
      <button class="button learn-more" @click="learnMore">{{ $t('home.learnMore') }}</button>
      <button class="button buy" @click="buy">{{ $t('home.buy') }}</button>
    </div>
    <!-- 电脑端图片 -->
    <img class="ipad-image pc-only" src="../static/home/s_01.png" alt="产品展示图">
  </div>
</template>

<script>
export default {
  name: 'home',
  components: {},
  data() {
    return {
      isMobile: false // 新增移动端判断标识
    }
  },
  methods: {
    learnMore() {
      let path = this.$route.path;
      if (path.startsWith('/zh')) {
        this.$router.push('/zh/series-s').then(() => {
          window.location.reload();
        });
      }
      if (path.startsWith('/en')) {
        this.$router.push('/en/series-s').then(() => {
          window.location.reload();
        });
      }
    },
    buy() {
      let path = this.$route.path;
      if (path.startsWith('/zh')) {
        this.$router.push('/zh/contact')
      }
      if (path.startsWith('/en')) {
        this.$router.push('/en/contact')
      }
    },
    // 新增：检测设备类型
    checkDevice() {
      this.isMobile = window.innerWidth <= 768;
    },
    // 新增：处理窗口大小变化
    handleResize() {
      this.checkDevice();
    }
  },
  mounted() {
    // 初始化设备检测
    this.checkDevice();
    window.addEventListener('resize', this.handleResize);

    const container = this.$el;
    const el1 = container.querySelector('.container-p');
    const el2 = container.querySelector('.container-p2');
    const el3 = container.querySelector('.learn-more');
    const el4 = container.querySelector('.buy');
    const el5 = container.querySelector('.ipad-image');

    const tl = this.$gsap.timeline({
      defaults: {duration: 1, ease: 'power3.out'},
    });

    this.$gsap.set([el1, el2, el3, el4], {
      opacity: 0,
      y: 20
    });

    // 移动端动画调整：根据设备类型改变初始位置
    this.$gsap.set(el5, {
      opacity: 0,
      x: this.isMobile ? 0 : '10%', // 移动端从下方进入，而非右侧
      y: this.isMobile ? '20%' : 0
    });

    tl
        // 移动端图片动画调整：从下往上进入
        .to(el5, {
          x: 0,
          y: 0,
          opacity: 1,
          duration: this.isMobile ? 1 : 1.2
        }, 0.2)

        .to(el1, {
          opacity: 1,
          y: 0
        }, 0.4)

        .to(el2, {
          opacity: 1,
          y: 0
        }, 0.6)

        .to([el3, el4], {
          opacity: 1,
          y: 0,
          scale: 1.05
        }, 0.8)

        .to([el3, el4], {
          scale: 1,
          duration: 0.3
        });
  },
  beforeDestroy() {
    // 移除事件监听，防止内存泄漏
    window.removeEventListener('resize', this.handleResize);
  }
}
</script>

<style>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 70vh;
  background-color: #f5f5f7;
  color: black;
  padding: 20px;
  box-sizing: border-box;
  margin-top: 30px;
  margin-bottom: 10px;
}

.container-p {
  margin-top: 20px;
  font-size: 2.5em;
  margin-bottom: 10px;
  text-align: center;
}

.container-p2 {
  font-size: 1.2em;
  margin-bottom: 22px;
  text-align: center;
  max-width: 80%;
  margin-top: 0px;
}

.button-group {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.button {
  font-family: 'TaiShifont', sans-serif;
  padding: 10px 20px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 1em;
  transition: all 0.3s ease;
}

.learn-more {
  background-color: #007AFF;
  color: #fff;
  border: none;
}

.buy {
  background-color: transparent;
  color: #007AFF;
  border: 1px solid #007AFF;
}

.ipad-image {
  margin-top: 25px;
  max-width: 80%;
  height: auto;
}

/* 电脑端专用元素 */
.pc-only {
  display: block;
}

/* 移动端专用容器默认隐藏 */
.mobile-image-container {
  display: none;
}

/* 手机端适配 - 屏幕宽度小于768px时 */
@media (max-width: 768px) {
  /* 切换显示移动/电脑端图片 */
  .mobile-image-container {
    display: block;
    width: 100%;
    text-align: center;
  }
  .pc-only {
    display: none;
  }

  .container {
    min-height: auto; /* 自动适应内容高度 */
    padding: 30px 15px;
    margin-top: 60px; /* 避开导航栏 */
  }

  .container-p {
    font-size: 1.8em; /* 优化移动端字体大小 */
    margin-top: 15px;
    line-height: 1.3; /* 优化行高 */
    max-width: 100%;
  }

  .container-p2 {
    font-size: 1em;
    max-width: 90%;
    margin-bottom: 25px;
    line-height: 1.5;
  }

  .button-group {
    flex-direction: column; /* 按钮垂直排列 */
    gap: 12px;
    width: 90%; /* 按钮组占满宽度 */
    margin-bottom: 15px;
  }

  .button {
    width: 100%;
    padding: 12px 0; /* 增大点击区域 */
    font-size: 1em;
  }

  .ipad-image {
    max-width: 90%;
    margin-top: 0;
  }
}

/* 小屏手机适配 - 屏幕宽度小于480px时 */
@media (max-width: 480px) {
  .container-p {
    font-size: 1.5em;
  }

  .container {
    padding: 20px 10px;
  }

  .button {
    padding: 11px 0;
  }
}
</style>
